import TeamArchive from "./TeamArchive";

export default TeamArchive;
